<template>
  <div>
    <div class="h2">
      Informations Personnelles
    </div>

    <!-- Numéro de sécurité social -->
    <InputText
      v-maska="'# ## ## ## ### ### ##'"
      label="Votre numéro de sécurité sociale"
      slug="numSecu"
      :model="numSecu"
      :v$="v$"
      @input="$emit('update:numSecu', $event.target.value)"
    />

    <!-- Organisme de rattachement -->
    <InputText
      v-maska="'## ### ####'"
      label="Votre régime/Caisse/Centre de rattachement"
      slug="organisme"
      :model="organisme"
      :v$="v$"
      @input="$emit('update:organisme', $event.target.value)"
    />

    <!-- Numéro de sécurité social du conjoint-->
    <InputText
      v-if="displayConjoint"
      v-maska="'# ## ## ## ### ### ##'"
      label="Le numéro de sécurité sociale de votre conjoint"
      slug="numSecuConjoint"
      :model="numSecuConjoint"
      :v$="v$"
      @input="$emit('update:numSecuConjoint', $event.target.value)"
    />

    <!-- Organisme de rattachement du conjoint -->
    <InputText
      v-if="displayConjoint"
      v-maska="'## ### ###'"
      label="Le régime/Caisse/Centre de rattachement de votre conjoint"
      slug="organismeConjoint"
      :model="organismeConjoint"
      :v$="v$"
      @input="$emit('update:organismeConjoint', $event.target.value)"
    />

    <div
      v-for="idxEnfant in nbEnfants"
      :key="idxEnfant"
    >
      <ChildForm
        v-if="enfants[idxEnfant-1]"
        :display-conjoint="displayConjoint"
        :idx-enfant="idxEnfant"
        :nom="enfants[idxEnfant-1].nom"
        :prenom="enfants[idxEnfant-1].prenom"
        :sexe="enfants[idxEnfant-1].sexe"
        :date-de-naissance="enfants[idxEnfant-1].dateDeNaissance"
        :ayant-droit="enfants[idxEnfant-1].ayantDroit"
        :organisme="enfants[idxEnfant-1].organisme"
        :num-secu="enfants[idxEnfant-1].numSecu"
        :date-effet="dateEffet"
        :server-errors="serverErrors"
        :data-cy="'enfant_' + idxEnfant"
        @update:nom="updateChild(idxEnfant, 'nom', $event)"
        @update:prenom="updateChild(idxEnfant, 'prenom', $event)"
        @update:sexe="updateChild(idxEnfant, 'sexe', $event)"
        @update:date-de-naissance="updateChild(idxEnfant, 'dateDeNaissance', $event)"
        @update:ayant-droit="updateChild(idxEnfant, 'ayantDroit', $event)"
        @update:organisme="updateChild(idxEnfant, 'organisme', $event)"
        @update:num-secu="updateChild(idxEnfant, 'numSecu', $event)"
      />
    </div>
  </div>
</template>

<script>

import useVuelidate from '@vuelidate/core'
import {frenchSocialSecurityNumber, required, requiredIf, serverError} from "src/modules/shared/validators/validators";
import {computed } from "vue";
import InputText from "src/modules/shared/components/Form/InputText";
import ChildForm from "src/modules/souscription/components/ChildForm";

export default {
  name: "PersonalInformationForm",
  components: {
    ChildForm,
    InputText,
  },
  props: {
    serverErrors: {
      type: Array,
      required: true
    },
    numSecu: {
      type: String,
      required: true
    },
    numSecuConjoint: {
      type: String,
      required: true
    },
    organisme: {
      type: String,
      required: true
    },
    organismeConjoint: {
      type: String,
      required: true
    },
    displayConjoint: {
      type: Boolean,
      required: true
    },
    nbEnfants: {
      type: Number,
      required: true
    },
    enfants: {
      type: Array,
      required: true
    },
    dateEffet: {
      type: String,
      required: true
    }
  },
  emits: [
    'update:numSecu',
    'update:organisme',
    'update:numSecuConjoint',
    'update:organismeConjoint',
    'update:enfants'
  ],
  setup (props, {emit}) {
    const validations = computed(() => ({
      numSecu: {
        required: required,
        frenchSocialSecurityNumber,
        serverError: serverError(props, 'numSecu')
      },
      numSecuConjoint: {
        requiredIf: requiredIf(props.displayConjoint),
        frenchSocialSecurityNumber,
        serverError: serverError(props, 'numSecuConjoint')
      },
      organisme: {
        required,
        serverError: serverError(props, 'organisme')
      },
      organismeConjoint: {
        requiredIf: requiredIf(props.displayConjoint),
        serverError: serverError(props, 'organismeConjoint')
      },
    }))

    const v$ = useVuelidate(validations, props)

    const updateChild = (childIdx, field, value) => {
      console.debug('[PersonalInformationFrom]', 'updateChild', childIdx, field, value)
      const enfants = JSON.parse(JSON.stringify(props.enfants))
      enfants[childIdx-1][field] = value
      emit('update:enfants', enfants)
    }

    return { v$, updateChild }
  },
  watch: {
    serverErrors () {
      this.v$.$reset()
      this.v$.$touch()
    }
  },
}
</script>

<style scoped>

</style>
